import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { AccountInformationTable } from '@/features/payment-management/account-information/table';
import { Translation } from '@/hoslog-intl';
import { UserFriendIcon } from '@/icons';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/payment-management/account-information/')({
  loader: () => ({
    crumb: <CrumbTitle id="paymentManagement.accountInformation.crumb.accountInformation" icon={UserFriendIcon} />,
    title: <Translation id="paymentManagement.accountInformation.page.title" />,
  }),
  component: AccountInformationTable,
});
